import Axios from "axios";

export default function DcategoryPriority(appliedCounsellingId){
     console.log(appliedCounsellingId);
    let response = Axios.get(process.env.REACT_APP_GATEWAY_URL, {
        params: {
            a:'dcategoryPriority',
            appliedCounsellingId
          
        }
    });
    return response;
}